export class FiltrosExclusion {
  "anyo": number = 0;
  "periodoId": number = 0;
  "sedeId": number = 0;
  "tipoAsignaturaId": number = 0;
  "asignaturaId": number = 0;
  "seccionId": number = 0
}
export interface ISedes {
  "sedes": [
    {
      sedeId: number,
      codigo: string,
      descripcion: string
    }
  ]
}
export interface ITipoAsignatura {
  "tpoAsignaturas": [
    {
      tpoAsignaturaId: number,
      codigo: string,
      descTpoAsignatura: string
    }
  ]
}

export interface ICategoriaAsignatura {
  categoriaAsignaturaDTOList: [
    {
      idCategoria: number,
      descCategoria: string
    }
  ]
}
export interface ISiglaAsignatura {
  "asignaturas": [
    {
      id: number,
      codigo: string
    }
  ]
}

export interface ISeccion {
  "secciones": [
    {
      id: number,
      descSeccion: string,
      codigo: string
    }
  ]
}
export interface IBusqueda {
  anyoAcademico: number,
  periodoAcademicoId: number,
  sedeId: number,
  sede: string,
  idSeccion: number,
  codigoSeccion: string,
  descSeccion: string,
  tpoAsignaturaId: number,
  tipoAsignatura: string,
  asignaturaId: number,
  usuario: string,
  descAsignatura: string,
  catAsignaturaId?: number,
  fecha: string,
  excluir: boolean
}

export interface IDescarga {
  archivo: string,
  nombreArchivo: string,
  extension: string,
  valor: boolean,
  error: {
    mensaje: string
  } | null
}
export interface IGuardar {
  anyoAcademico: number,
  periodoAcademicoId: number,
  sedeId: number,
  sede: string,
  idSeccion: number,
  codigoSeccion: string,
  descSeccion: string,
  tpoAsignaturaId: number,
  tipoAsignatura: string,
  asignaturaId: number,
  usuario: string,
  fecha: string,
  excluir: boolean
}

export interface IExclusionAsignaturaBody {
  anyo: number,
  periodoId: number,
  sedeId: number,
  catAsignaturaId: number,
  asignaturaId: number,
  seccionId: number,
  excluir: boolean
}

export interface IExclusionAsignaturaRes {
  valor: boolean,
  error: {
    mensaje: string
  } | null
}